import { APP_INITIALIZER, NgModule } from '@angular/core';

import { V12RetailFinanceService } from './v12-retail-finance.service';

@NgModule({
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (v12RetailFinanceService: V12RetailFinanceService) => () => {},
            deps: [V12RetailFinanceService],
            multi: true
        }
    ]
})
export class V12RetailFinanceModule {}
